export default function () {
  return {
    products: [],
    drinks: [],
    deliveryMethod: null,
    paymentMethod: null,
    location: null,
    coupon: null,
    totalPrice: 0,
    totalDiscount: 0,
    previousOrder: null,
  };
}
